import { render, staticRenderFns } from "./QrGenerator.vue?vue&type=template&id=2c53795e&scoped=true"
import script from "./QrGenerator.vue?vue&type=script&lang=js"
export * from "./QrGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53795e",
  null
  
)

export default component.exports